export const MINING_PROXY = "wss://smiling-tilda-mono.koyeb.app/proxy"
